"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("./utils");
class RetryOptions {
    constructor(firstRetryIntervalInMilliseconds, maxNumberOfAttempts) {
        this.firstRetryIntervalInMilliseconds = firstRetryIntervalInMilliseconds;
        this.maxNumberOfAttempts = maxNumberOfAttempts;
        utils_1.Utils.throwIfNotNumber(firstRetryIntervalInMilliseconds, "firstRetryIntervalInMilliseconds");
        utils_1.Utils.throwIfNotNumber(maxNumberOfAttempts, "maxNumberOfAttempts");
        if (firstRetryIntervalInMilliseconds <= 0) {
            throw new RangeError("firstRetryIntervalInMilliseconds value must be greater than 0.");
        }
    }
}
exports.RetryOptions = RetryOptions;
//# sourceMappingURL=retryoptions.js.map